import React, { useEffect } from "react";
import {
  Box,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Badge,
  IconButton,
  ListItemButton
} from "@mui/material";
import OnlineStatus from "../components/OnlineStatus";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatIcon from "@mui/icons-material/Chat";
import PersonIcon from "@mui/icons-material/Person";
import CachedIcon from "@mui/icons-material/Cached";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import apilink from "../globals/Baseurls";
import user1 from "./dummyuser2.png";
import { ToastContainer, toast } from "react-toastify";
import heartsBg from "./hearts4.png";
import heartsBg2 from "./hearts4.png";

export default function Chats() {
  const [tab, setTab] = React.useState(2);
  const [chathistory, setChathistory] = React.useState([]);
  const navigate = useNavigate();

  const startChat = async (conversation_id, user_id, name, photo) => {
    const chatData = {
      conversation_id,
      user_id,
      name,
      photo
    };
    localStorage.setItem("chatSessionData", JSON.stringify(chatData));
    navigate(`/chat`)
  };

  const refetchChats = async () => {
    toast.success("Refreshing chats...", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    try {
      const { token } = JSON.parse(localStorage.getItem("userSessionData"));
      const res = await axios.get(`${apilink.link}/mychats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res.data.chats);
      setChathistory(res.data.chats);
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert("Failed to load matches");
    }
  };
  const fetchChats = async () => {
    try {
      const { token } = JSON.parse(localStorage.getItem("userSessionData"));
      const res = await axios.get(`${apilink.link}/mychats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res.data.chats);
      setChathistory(res.data.chats);
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert("Failed to load matches");
    }
  };

  useEffect(() => {
    fetchChats();
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "#f4f6fb",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* 🔝 Sticky Top Bar */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 20,
          backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.7), rgba(255,255,255,0.9)),
                    url(${heartsBg})
                    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          p: 2,
          borderBottom: "1px solid #eee",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">Chats</Typography>
        <IconButton onClick={() => refetchChats()}>
          <CachedIcon />
        </IconButton>
      </Box>

      {/* 📜 Chats list */}
      <Box sx={{ flex: 1, overflowY: "auto", pb: 10 }}>
        <List>
          {chathistory.map((c) => (
            <ListItem key={c.conversation_id} divider>
              <ListItemButton
                onClick={() =>
                  startChat(`${c.conversation_id}`, `${c.user_id}`, `${c.name}`, `${c.photo}`)
                }
              >
                {/* Avatar */}
                <ListItemAvatar>
                  <Badge
                    color="error"
                    badgeContent={c.unread}
                    invisible={c.unread === 0}
                  >
                    <Avatar
                      src={
                        c.photo
                          ? `${apilink.base_link}/storage/${c.photo}`
                          : user1
                      }
                    />
                  </Badge>
                </ListItemAvatar>

                {/* Text */}
                <ListItemText
                  primaryTypographyProps={{ component: "div" }}
                  secondaryTypographyProps={{ component: "div" }}
                  primary={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {/* Name + Online Dot */}
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <OnlineStatus userId={c.user_id} size={12} />
                        <Typography fontWeight="bold" sx={{ ml: 1 }}>
                          {c.name}
                        </Typography>
                      </Box>

                      {/* Chat Type Badge */}
                      <Box
                        sx={{
                          px: 1,
                          py: 0.3,
                          borderRadius: 2,
                          fontSize: 11,
                          fontWeight: "bold",
                          bgcolor:
                            c.chat_type === "superconnect"
                              ? "#e91e63"
                              : "rgba(233,30,99,0.15)",
                          color:
                            c.chat_type === "superconnect"
                              ? "#ece7e7"
                              : "#e91e63",
                        }}
                      >
                        {c.chat_type === "superconnect" ? "💫 Super" : "💘 Match"}
                      </Box>
                    </Box>
                  }
                  secondary={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        mt: 0.5,
                      }}
                    >
                      {/* Message Preview */}
                      <Typography
                        variant="body2"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "75%",
                          color: "text.secondary",
                        }}
                      >
                        {c.msg}
                      </Typography>

                      {/* Time */}
                      <Typography
                        variant="caption"
                        sx={{ flexShrink: 0, ml: 1, color: "text.secondary" }}
                      >
                        {c.time}
                      </Typography>
                    </Box>
                  }
                />
              </ListItemButton>
            </ListItem>


          ))}
        </List>
      </Box>


      {/* ⬇️ Floating Bottom Tab */}
      <Paper elevation={6} sx={tabStyle}>
        <BottomNavigation
          value={tab}
          sx={{
            height: 66,
            paddingTop: "6px",
            paddingBottom: "6px",
            borderRadius: "10px",
            backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0.7)),
                    url(${heartsBg2})
                    `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            "& .MuiBottomNavigationAction-root": {
              color: "#999", // inactive
            },
            "& .MuiBottomNavigationAction-root.Mui-selected": {
              color: "#010832", // active icon + label
            },
          }}
          onChange={(e, v) => {
            setTab(v);
            if (v === 0) navigate("/discover");
            if (v === 1) navigate("/activity");
            if (v === 3) navigate("/profile");
          }}
          showLabels
        >
          <BottomNavigationAction label="Explore" icon={<WhatshotIcon />} />
          <BottomNavigationAction label="Connections" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Chats" icon={<ChatIcon />} />
          <BottomNavigationAction label="Profile" icon={<PersonIcon />} />
        </BottomNavigation>
      </Paper>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Box>
  );
}

const tabStyle = {
  position: "fixed",
  bottom: 12,
  left: "50%",
  transform: "translateX(-50%)",
  width: "calc(100% - 24px)",
  maxWidth: 420,
  borderRadius: 8,
};
